import React from "react";
import Hero from "./Hero";
import DEFAULT_HERO_IMAGE from "../../assets/Images/hero-bg.png";

/**
 * Hero receives data from each page. For now every page sends the same content (via DEFAULT_HERO in data);
 * later you can set heroIntro, heroImage, heroImageAlt, heroCredibility, heroBottomParagraph per page.
 * If page.heroImage is omitted, the default main hero image is used.
 */
export default function MedicalPageLayout({ page, children }) {
  if (!page) return null;
  const {
    title,
    paragraphs,
    heroSubheading,
    heroIntro,
    heroImage,
    heroImageAlt,
    heroCredibility,
    heroBottomParagraph,
  } = page;

  return (
    <>
      <Hero
        title={title}
        subheading={heroSubheading}
        intro={heroIntro}
        image={heroImage !== undefined ? heroImage : DEFAULT_HERO_IMAGE}
        imageAlt={heroImageAlt}
        credibility={heroCredibility}
        bottomParagraph={heroBottomParagraph}
      />
      <section className="bg-white py-16">
        <div className="mx-auto container-app">
          <div className="max-w-[980px]">
            {paragraphs && paragraphs.length > 0 && (
              <div className="space-y-6 text-[15px] leading-7 text-neutral-900/85">
                {paragraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            )}
            {children}
          </div>
        </div>
      </section>
    </>
  );
}
